import { SectionMetaDataType } from 'generated/graphql';
import { incomeConditionTypesEnum } from 'questionFlow/flows/defaultIncome/types';

const getIncomeCondition = (data: SectionMetaDataType, conditionName: incomeConditionTypesEnum) =>
  data.incomeSectionMetaData?.conditions?.find(cond => cond?.name === conditionName);

export default getIncomeCondition;
